export default "__VITE_ASSET__BGNdLIKV__"